<template>
  <div>自定义链接</div>
</template>

<script>
export default {};
</script>

<style>
</style>